import {capitalizeFirstLetter} from "../../../../../../util/string-util";
import {useAppSelector} from "../../../../../../redux/hooks";
import {
  getMySongsPageSongSelectedSongDetailsLessonsForDisplayByDifficultyCategory,
  ISongDetailsLessonForListDisplay,
} from "../../../../modules/my-songs-page-store/mySongsPage.selectors";



export interface ISongDetailsLessonsListGroupLogic {
  groupTitle: string;
  groupCount: number;
  groupLessons: ISongDetailsLessonForListDisplay[];
}

export const useSongDetailsLessonsListGroupLogic = (difficultyCategory: string): ISongDetailsLessonsListGroupLogic => {
  const groupTitle = capitalizeFirstLetter(difficultyCategory);
  const groupLessons = useAppSelector((store) => getMySongsPageSongSelectedSongDetailsLessonsForDisplayByDifficultyCategory(store, difficultyCategory));

  const orderedSubcategories = [
    'Easy',
    'Moderate',
    'Hard',
  ];

  const orderedArrangementTypes = [
    'Play-along',
    'Riff',
    'Short',
    'Full Song'
  ];

  groupLessons.sort((a, b) => {
    //Sort first by difficulty, then by arrangement type

    const elementADifficultyRank = orderedSubcategories.indexOf(a.difficulty);
    const elementBDifficultyRank = orderedSubcategories.indexOf(b.difficulty);

    const elementAArrangementTypeRank = orderedArrangementTypes.indexOf(a.title);
    const elementBArrangementTypeRank = orderedArrangementTypes.indexOf(b.title);

    //Compare difficulties
    if (elementADifficultyRank < elementBDifficultyRank) {
      return -1;
    }

    if (elementADifficultyRank > elementBDifficultyRank) {
      return 1;
    }

    // Difficulties are equal, now compare arrangement types
    if (elementAArrangementTypeRank < elementBArrangementTypeRank) {
      return -1;
    }

    if (elementAArrangementTypeRank > elementBArrangementTypeRank) {
      return 1;
    }

    return 0;
  });

  const groupCount = groupLessons.length;
  return {
    groupTitle,
    groupLessons,
    groupCount,
  };
}
